module.exports = __webpack_public_path__ + "4c724a3b72329706c8157dcacfa81be8.png";